const FALLBACK_API_PORT = '5000';

function trimTrailingSlash(value) {
  return String(value || '').trim().replace(/\/+$/, '');
}

/** Misconfigured prod: REACT_APP_API_BASE_URL=https://host:5000 — browser cannot reach :5000; API is on same host /api. */
function normalizeMisconfiguredPublicBase(base) {
  const b = trimTrailingSlash(String(base || ''));
  if (!b || typeof window === 'undefined' || !window.location) return b;
  try {
    const u = new URL(b);
    if (u.hostname !== window.location.hostname) return b;
    if (u.port === '5000') {
      return `${window.location.protocol}//${window.location.host}/api`;
    }
  } catch (_) {
    /* ignore */
  }
  return b;
}

/**
 * Base URL for Flask API calls (fetch + EventSource).
 * Production behind reverse-proxy (same origin): set at build time to
 *   https://your-domain/api
 * so paths become https://your-domain/api/aggregate-... (nginx strips /api → backend).
 */
export function getApiBaseUrl() {
  const envBase =
    typeof process !== 'undefined' && process.env ? process.env.REACT_APP_API_BASE_URL : '';
  if (envBase && String(envBase).trim()) {
    return normalizeMisconfiguredPublicBase(trimTrailingSlash(envBase));
  }

  const useRelativeApi =
    typeof process !== 'undefined' &&
    process.env &&
    String(process.env.REACT_APP_USE_RELATIVE_API || '').trim().toLowerCase() === 'true';

  if (useRelativeApi && typeof window !== 'undefined' && window.location) {
    const origin = `${window.location.protocol}//${window.location.host}`;
    return `${trimTrailingSlash(origin)}/api`;
  }

  // CRA dev (localhost:3000): same-origin /api via setupProxy.js — avoids cross-origin CORS
  // and browser per-host HTTP/1.1 connection limits (admin opens several SSE streams).
  if (typeof window !== 'undefined' && window.location) {
    const host = (window.location.hostname || '').toLowerCase();
    const port = String(window.location.port || '').trim();
    if ((host === 'localhost' || host === '127.0.0.1') && port === '3000') {
      const protocol = window.location.protocol || 'http:';
      return `${trimTrailingSlash(`${protocol}//${window.location.host}`)}/api`;
    }
    if (host === 'localhost' || host === '127.0.0.1') {
      const protocol = window.location.protocol || 'http:';
      return `${protocol}//${host}:${FALLBACK_API_PORT}`;
    }
    const origin = `${window.location.protocol}//${window.location.host}`;
    return `${trimTrailingSlash(origin)}/api`;
  }

  return `http://localhost:${FALLBACK_API_PORT}`;
}

